module.exports = __webpack_public_path__ + "static/media/NewsletterLogo.e95bd59a.svg";